import React from "react";
import "./style.scss";

const WaveIcon = (props) => {
  return (
    <div className="wave">
        <div className="sound-waves">
            <div className="sound-wave"></div>
            <div className="sound-wave"></div>
            <div className="sound-wave"></div>
        </div>
    </div>
  );
};
export default WaveIcon;
